<template>
  <div>
    <page-size-select
      :pagination="pagination"
      :default-page-size="defaultPageSize"
    />
    <base-list
      v-bind="{
        ...$props,
        ...$attrs,
        ...$slots,
        ...$scopedSlots,
        ...$listeners
      }"
      :pagination="false"
    />
    <a-row
      v-if="pagination && pagination.pageSize"
      class="pagination"
      type="flex"
      justify="end"
    >
      <back-to-top-btn />
      <custom-pagination :pagination="pagination" />
    </a-row>
  </div>
</template>
<script>
import { List } from 'ant-design-vue'
import PageSizeSelect from './PageSizeSelect'
import BackToTopBtn from './BackToTopBtn'
import CustomPagination from './CustomPagination'

export default {
  components: {
    baseList: List,
    PageSizeSelect,
    BackToTopBtn,
    CustomPagination
  },
  props: {
    pagination: {
      type: [Boolean, Object],
      required: false
    },
    defaultPageSize: {
      type: Number,
      required: false
    }
  }
}
</script>
<style lang="scss" scoped>
.pagination {
  padding: 16px 0;
}

::v-deep .arrow-icon {
  transition: 0.3s transform;

  &--rotated {
    transform: rotate(-180deg);
  }
}
</style>
